import React, {useEffect, useState} from 'react'
import {Header, Button, Icon, ButtonGroup} from '@thryvlabs/maverick'
import {useAuthClient} from '../../utils/use-auth-client'
import {toast} from 'react-toastify'
import AsyncSelect from 'react-select/async'
import {useLocation} from 'react-router'
import {useSelector, useDispatch} from 'react-redux'
import {shallowEqual} from 'react-redux'
import {selectManualCoupons, setManualCoupons} from '../../app-store/coupon'

function CouponModal({
  close,
  code,
  setCode,
  selectedCountry,
  selectedCentersAndApps,
  accountInfo,
  order,
}) {
  const dispatch = useDispatch()
  const ccCouponInfo = useSelector(selectManualCoupons, shallowEqual)
  // const [coupon, setCoupon] = useState(code)
  // const [selectedCoupon, setSelectedCoupon] = useState(null)
  const [addedCoupons, setAddedCoupons] = useState([])
  const [maxAllowedCoupons, setMaxAllowedCoupons] = useState(0)
  const client = useAuthClient()
  const {pathname} = useLocation()

  useEffect(async () => {
    // fetch the max number of manual coupons allowed
    let response = await client(
      'keappartner/fetchConfigLookupValue/maxAllowedManualCoupons',
    )
    setMaxAllowedCoupons(response?.data[0]?.value)
    console.log('maxAllowedCoupons :: ', maxAllowedCoupons)

    if (ccCouponInfo && ccCouponInfo.length > 0 && addedCoupons.length === 0) {
      console.log('Inside update of setAddedCoupons')
      setAddedCoupons(ccCouponInfo)
    }
  }, [])

  const handleSubmitNew = async () => {
    console.log('Inside handleSubmitNew ')
    dispatch(setManualCoupons(addedCoupons))
    // setOrderCouponCodes(addedCoupons)
  }

  const validateCouponNew = async coupon => {
    try {
      const codes = []
      for (const key in selectedCentersAndApps) {
        codes.push(...selectedCentersAndApps[key].map(x => x.code))
      }
      console.log('codes ::', codes)
      let url = `orders/coupon/validate?couponCode=${coupon}&country=${selectedCountry}&addonsString=${codes.join()}`
      const response = await client(url)
      return response
    } catch (error) {
      console.log('error  is :: ', error)
      return {isValid: false}
    }
  }
  const handleRemoveCoupon = async e => {
    console.log('Coupon removed is :: ', e)
    console.log(addedCoupons.filter(coupon => coupon.code != e))
    let couponsAfterRemoving = addedCoupons.filter(coupon => coupon.code != e)
    setAddedCoupons(couponsAfterRemoving)
  }
  const handleChange = async e => {
    console.log('Coupon selected is  :: ', e)
    let newCoupons = []
    let selectedProducts = []
    let auto_coupon = e.autoCoupon ? e.autoCoupon : null
    let auto_coupon_prods =
      e.autoCouponProds?.length > 0 ? e.autoCouponProds.split(',') : null
    let incompatibleCoupons = e.incompatibles?.split(',')
    const isNewOrder = pathname === '/order/new'
    // Fetch existing coupons from recurly
    let recurlyValidationError = false
    if (!isNewOrder) {
      const existingCoupons = await client(
        `accounts/5/coupon-redemptions?thryvId=${
          order?.CCAccountInfo?.thryvId || accountInfo?.thryvID
        }`,
      )
      let activeCouponCodes = existingCoupons.map(coupon => coupon.code)
      console.log('activeCouponCodes : ', activeCouponCodes)
      // Check if the coupon being added, is already present in recurly
      if (activeCouponCodes.includes(e.value)) {
        toast.error(
          'Oops! Looks like these coupons are already applied to the client’s account, so they’ll be removed from this order. Don’t worry, the right discounts will still apply when their payment is processed',
        )
        recurlyValidationError = true
      }
      // Check if coupon is incompatible with any of the existing coupons in recurly
      if (
        incompatibleCoupons &&
        incompatibleCoupons.length > 0 &&
        incompatibleCoupons.some(incompatibleCoupon =>
          activeCouponCodes.includes(incompatibleCoupon),
        )
      ) {
        toast.error(
          'The coupon you are trying to apply can not be combined with an existing coupon on your account. Coupon not applied.',
        )
        recurlyValidationError = true
      }
    }
    if (!recurlyValidationError) {
      // Bundle coupon validation
      let bundleCouponValidationError = false
      if (e.bundle_combinations) {
        let bundle_combinations = e.bundle_combinations
        const codes = []
        for (const key in selectedCentersAndApps) {
          codes.push(...selectedCentersAndApps[key].map(x => x.code))
        }
        // Filter the bundle combinations based on selected products in the order
        let matchedBundleCombination = bundle_combinations.filter(
          combination => {
            let combination_products = combination.split(',')
            console.log('combination_products :', combination_products)
            if (
              combination_products.every(combinationProduct =>
                codes.includes(combinationProduct),
              )
            ) {
              return true
            }
          },
        )
        // If no bundle combination found, show warning
        if (
          !matchedBundleCombination ||
          matchedBundleCombination.length === 0
        ) {
          bundleCouponValidationError = false
          // toast.warn(
          //   'Oops! Some items in your cart don’t qualify for this bundle coupon. Please update your cart to continue.',
          // )
          alert(
            'Oops! Some items in your cart don’t qualify for this bundle coupon. Please update your cart to continue.',
          )
        }
      }
      // Check if coupon selected is already added in the modal
      if (
        !bundleCouponValidationError &&
        !addedCoupons.find(coupon => coupon?.code === e.value)
      ) {
        // validate coupon
        let recurlyResp = await validateCouponNew(e.value)
        if (recurlyResp.isValid) {
          newCoupons.push({...recurlyResp, incompatibles: e.incompatibles})
          toast.success('Coupon applied.')
          // Check for auto add coupons
          if (
            auto_coupon &&
            !addedCoupons.find(coupon => coupon?.code === auto_coupon)
          ) {
            for (const key in selectedCentersAndApps) {
              selectedProducts.push(
                ...selectedCentersAndApps[key].map(x => x.code),
              )
            }
            if (auto_coupon_prods && auto_coupon_prods.length > 0) {
              if (
                auto_coupon_prods.some(autoCouponProd =>
                  selectedProducts.includes(autoCouponProd),
                )
              ) {
                let recurlyResp = await validateCouponNew(auto_coupon)
                if (recurlyResp.isValid) {
                  newCoupons.push({
                    ...recurlyResp,
                    incompatibles: e.incompatibles,
                  })
                  toast.success('Coupon applied.')
                } else {
                  toast.error('Invalid coupon.')
                }
              }
            } else {
              let recurlyResp = await validateCouponNew(auto_coupon)
              if (recurlyResp.isValid) {
                newCoupons.push({
                  ...recurlyResp,
                  incompatibles: e.incompatibles,
                })
                toast.success('Coupon applied.')
              } else {
                toast.error('Invalid coupon.')
              }
            }
          }
          // Check for incompatible coupons for the newly selected coupon and remove them from coupon modal list
          // let incompatibleCoupons = e.incompatibles?.split(',')
          if (incompatibleCoupons && incompatibleCoupons.length > 0) {
            const removedCodes = addedCoupons
              .filter(coupon => incompatibleCoupons.includes(coupon.code))
              .map(coupon => coupon.code)
            if (removedCodes.length > 0) {
              toast.info(
                `${removedCodes.join(', ')} can't be combined with ${
                  e.value
                } and was removed.`,
              )
            }
            setAddedCoupons([
              ...addedCoupons.filter(
                coupon => !incompatibleCoupons.includes(coupon.code),
              ),
              ...newCoupons,
            ])
          } else {
            console.log('newCoupons :: ', newCoupons)
            setAddedCoupons(prevItems => [...prevItems, ...newCoupons])
          }
          // To display newly selected coupon on the drop down
          // setSelectedCoupon({
          //   label: e.value,
          //   value: e.value,
          // })
        } else {
          toast.error('Invalid coupon.')
        }
      }
    }
  }

  const loadOptions = (inputValue, callback) => {
    if (inputValue && inputValue.length >= 3) {
      fetchNameOptions(inputValue)
        .then(options => {
          callback(options)
        })
        // (Fixes OOE-UI-8F, OOE-UI-8T)
        .catch(() => callback([]))
    } else if (!inputValue) {
      callback([])
    }
  }

  const fetchNameOptions = async inputValue => {
    // the search term is free text - encode it so characters like "%" or "/"
    // cannot break the request path (Fixes OOE-UI-8T)
    const response = await client(
      `cc/order/fetchCoupons/${selectedCountry}/${encodeURIComponent(
        inputValue,
      )}`,
    )
    // let coupon_incompatibles =
    //   response && response.length > 0 && response[0].incompatibles
    //     ? response[0].incompatibles
    //     : null

    return (response ?? []).map(item => ({
      label: item.coupon_code,
      value: item.coupon_code,
      autoCoupon: item.autoAddCoupons,
      autoCouponProds: item.requiredProducts,
      incompatibles: item.incompatibles,
      bundle_combinations: item.bundle_combinations,
    }))
  }

  // const validateCoupon = async () => {
  //   if (coupon && ccCouponInfo?.code !== coupon) {
  //     setCoupon(coupon.trim())
  //     try {
  //       const codes = []
  //       for (const key in selectedCentersAndApps) {
  //         codes.push(...selectedCentersAndApps[key].map(x => x.code))
  //       }
  //       console.log('codes ::', codes)
  //       let url = `orders/coupon/validate?couponCode=${coupon}&country=${selectedCountry}&addonsString=${codes.join()}`
  //       const response = await client(url)
  //       if (response.isValid) {
  //         toast.success('Coupon applied.')
  //         setCcCouponInfo({
  //           ...response,
  //           code: coupon.trim(),
  //           incompatibles: couponIncompatibles,
  //         })
  //         setCode(coupon)

  //         if (!autoCoupon) {
  //           setCcAutoCouponInfo(null)
  //         } else {
  //           let url = `orders/coupon/validate?couponCode=${autoCoupon}&country=${selectedCountry}&addonsString=${codes.join()}`
  //           const response = await client(url)
  //           if (response.isValid) {
  //             toast.success('Coupon applied.')
  //             setCcAutoCouponInfo({
  //               ...response,
  //               code: autoCoupon.trim(),
  //               incompatibles: '',
  //             })
  //           }
  //         }
  //       }
  //       if (!response.isValid) {
  //         setCode('')
  //         toast.error('Invalid coupon.')
  //       }
  //     } catch (error) {
  //       setCode('')
  //       toast.error('Invalid coupon.')
  //       if (error.status === 404) {
  //         setCcCouponInfo({isValid: false})
  //       }
  //     }
  //   }
  // }

  // const handleSubmit = async () => {
  //   await validateCoupon()
  // }

  // const resetCoupon = async () => {
  //   setSelectedCoupon({label: '', name: ''})
  //   setCoupon(null)
  // }

  return (
    <div
      data-testid="coupon-modal"
      className="d-flex flex-column"
      style={{
        width: '500px',
        maxHeight: '80vh',
        overflowY: 'auto',
        gap: '30px',
      }}
    >
      <div className="w-100 d-flex align-items-center justify-content-between">
        <Header variant="h2" fontWeight="semibold">
          Coupons
        </Header>
        <Icon
          style={{cursor: 'pointer'}}
          onClick={close}
          type="regular"
          variant="x"
          height="18"
          width="18"
          color="#A3A5A7"
        />
      </div>
      {!(addedCoupons && addedCoupons.length >= maxAllowedCoupons) ? (
        <>
          <AsyncSelect
            cacheOptions
            placeholder="Enter a Coupon"
            dsiable={true}
            loadOptions={loadOptions}
            onChange={handleChange}
            value={''}
            theme={theme => ({
              ...theme,
              borderRadius: 0,
              colors: {
                ...theme.colors,
                primary25: 'silver',
                primary: 'black',
              },
            })}
          />
        </>
      ) : null}

      {/* {selectedCoupon && selectedCoupon.label && selectedCoupon.label.length ? (
        <>
          <Icon
            className="reset-button"
            type="regular"
            variant="circleX"
            color="#FF5000"
            style={{
              width: '18px',
              height: '18px',
              marginTop: '25px',
              marginLeft: '10px',
              marginRight: '10px',
              alignSelf: 'center',
            }}
            onClick={resetCoupon}
          />
        </>
      ) : null} */}
      {addedCoupons && addedCoupons.length > 0 ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            width: '100%',
          }}
        >
          {/* <h3
            style={{
              textAlign: 'left',
              fontWeight: 'bold',
            }}
          >
            Coupons added :
          </h3> */}
          {addedCoupons.map(coupon => {
            return (
              <div
                key={coupon.code + '_div'}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'left',
                }}
              >
                <span
                  style={{
                    // flex: 1,
                    // alignText: 'left',
                    marginRight: '5px',
                  }}
                  key={coupon.code}
                >
                  {coupon.description}
                </span>
                <button
                  style={{
                    width: '100px',
                  }}
                  onClick={() => handleRemoveCoupon(coupon.code)}
                >
                  <Icon
                    type={'regular'}
                    variant={`x`}
                    height={'15'}
                    width={'15'}
                    color={'#FF6100'}
                  />
                </button>
              </div>
            )
          })}
        </div>
      ) : null}
      <ButtonGroup
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          justifyContent: 'flex-end',
          columnGap: '16px',
          marginTop: '100px',
        }}
      >
        <Button variant="text" level={1} textVariant="light" onClick={close}>
          CANCEL
        </Button>
        <Button variant="primary" onClick={handleSubmitNew}>
          Apply
        </Button>
      </ButtonGroup>
    </div>
  )
}

export {CouponModal}
